import { apiUploader } from "./base";

// TODO: change AWS uploader 
export function awsUploader(formdata, config = {}) {
  let api = apiUploader();
  return api.post('v1/files/upload', formdata, config)
}